import type { FC } from 'react'

import { LoaderCircle } from '../LoaderCircle'

import './styles.scss'

export const PageLoader: FC = () => (
  <div className="ui-page-loader">
    <LoaderCircle size="regular" />
  </div>
)
